import React, {Component} from 'react';
import axios from '../../axios-signup';
import {Redirect} from 'react-router-dom';
import Error from '../../components/UI/Error';
import Privacy from '../../components/Static/Privacy';
import Terms from '../../components/Static/Terms';
import Header from '../../components/Header/Header';
import './Email.css';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap"
import {Loader} from 'react-overlay-loader'

class Email extends Component {
    state = {
        awsguid: '',
        emailAddress: '',
        acceptTerms: false,
        errorMsg: '',
        submitted: false,
        finished: false,
        showPrivacy: false,
        showTerms: false,
        loading: false
    };

    componentWillMount() {
        const params = new URLSearchParams(this.props.location.search);
        const guid = params.get('awsguid');
        this.setState({awsguid: guid});
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        axios
            .post("/email", {
                "emailAddress": this.state.emailAddress,
                "acceptTerms": this.state.acceptTerms,
                "awsGuid": this.state.awsguid,
            })
            .then((response) => {
                this.setState({submitted: true, finished: response.data.finished, loading: false})
            })
            .catch(error => {
                this.setState({errorMsg: error.response.data.error, loading: false})
            });
    };

    handleChange = (event) => {
        this.setState({emailAddress: event.target.value.trim()})
    };

    handleCheckbox = (event) => {
        let checked = this.toggleCheckbox();
        this.setState({acceptTerms: checked})
    };

    toggleCheckbox = () => {
        if (document.getElementById("checkbox_no1").checked) {
            document.getElementById("checkbox_no1").checked = false;
            return false;
        } else {
            document.getElementById("checkbox_no1").checked = true;
            return true;
        }
    };

    togglePrivacy = () => {
        this.setState({
            showPrivacy: !this.state.showPrivacy
        });
    };

    toggleTerms = () => {
        this.setState({
            showTerms: !this.state.showTerms
        });
    };

    handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            this.setState({loading: true});
            axios
                .post("/email", {
                    "emailAddress": this.state.emailAddress,
                    "acceptTerms": this.state.acceptTerms
                })
                .then((response) => {
                    this.setState({submitted: true, finished: response.data.finished, loading: false})
                })
                .catch(error => {
                    this.setState({errorMsg: error.response.data.error, loading: false})
                });
        }
    };


    render() {
        let redirect = null;
        if (this.state.submitted) {
            // if (this.state.finished) {
            //     redirect = <Redirect to={{pathname: '/signup/signup-done', state: {emailAddress: this.state.emailAddress}}}/>
            // } else {
                redirect = <Redirect
                    to={{pathname: '/signup/email-verification', state: {emailAddress: this.state.emailAddress}}}/>
            // }
        }

        return (
            <div>
                <Header currentWizard="1"/>
                <main role="main">
                    <Loader fullPage={true} loading={this.state.loading}/>
                    <section className="section yellow">
                        {redirect}
                        <div className="container">
                            <div className="row">
                                <div className="col-md-10 col-center text-center">
                                    <h1 className="black"><strong>Start Saving Today!</strong></h1>
                                    <h5 className="gray mb-4"><strong>Enter your Email address below to get
                                        started.</strong></h5>
                                    <Error errorMsg={this.state.errorMsg}
                                           divClass="col-lg-6 col-md-7 col-sm-7 col-center"/>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-7 col-sm-7 col-center">
                                            <div className="form-group">
                                                <input type="text" placeholder="Email address" className="form-control"
                                                       onChange={this.handleChange} onKeyPress={e => {this.handleKeyPress(e)}}/>
                                            </div>
                                            <div className="form-group mt-4-5 mb-4">
                                            <span className="cbContainer">
                                            <input type="checkbox" onChange={this.handleCheckbox} id="checkbox_no1"/>
                                                <span className="checkmark" onClick={this.handleCheckbox}/>
                                                <span className="ml-2 small label1" style={{clearLeft: true}}>Accept <a
                                                    href="#" onClick={e => {
                                                    e.preventDefault();
                                                    this.setState({showPrivacy: true})
                                                }}>Privay Policy</a> and <a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    this.setState({showTerms: true})
                                                }}>Terms and Conditions</a></span>
                                            </span>
                                            </div>
                                            <div className="form-group">
                                                <input type="submit" value="Signup" className="btn btn-primary"
                                                       onClick={this.handleSubmit}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-center" style={{marginTop:'30px'}}>
                                            Already have an account? <a href="https://dashboard.xosphere.io">Login</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Modal isOpen={this.state.showPrivacy} onHide={e => {
                        this.setState({showPrivacy: false})
                    }} toggle={this.togglePrivacy} size="lg">
                        <ModalHeader toggle={this.togglePrivacy}>Privacy Policy</ModalHeader>
                        <ModalBody>
                            <Privacy/>
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={e => {
                                this.setState({showPrivacy: false})
                            }}>Close</Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={this.state.showTerms} onHide={e => {
                        this.setState({showTerms: false})
                    }} toggle={this.toggleTerms} size="lg">
                        <ModalHeader toggle={this.toggleTerms}>End User License Agreement</ModalHeader>
                        <ModalBody>
                            <Terms/>
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={e => {
                                this.setState({showTerms: false})
                            }}>Close</Button>
                        </ModalFooter>
                    </Modal>
                </main>
            </div>
        )
    }
}

export default Email;